// Pagination and the product/store tab switch for the review sections.
// One instance per [data-reviews-root]; both the home and product sections use it.
(() => {
  const init = (root) => {
    const pageSize = Number(root.dataset.reviewsPages) || 1;
    const reviews = [...root.querySelectorAll('[data-reviews-page]')];
    const buttons = [...root.querySelectorAll('[data-reviews-page-button]')];
    const list = root.querySelector('[data-reviews-list]');
    const empty = root.querySelector('[data-reviews-empty]');
    const pager = root.querySelector('[data-reviews-pager]');
    let currentPage = 1;

    const showPage = (page) => {
      currentPage = Math.max(1, Math.min(Number(page), pageSize));
      reviews.forEach((review) =>
        review.classList.toggle('is-visible', review.dataset.reviewsPage === String(currentPage)));
      buttons.forEach((button) => {
        const value = button.dataset.reviewsPageButton;
        button.classList.toggle('is-selected', value === String(currentPage));
        if (value === 'next') button.disabled = currentPage === pageSize;
      });
    };

    buttons.forEach((button) => button.addEventListener('click', () => {
      const value = button.dataset.reviewsPageButton;
      showPage(value === 'next' ? currentPage + 1 : value);
      list?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }));

    const tabs = [...root.querySelectorAll('[data-reviews-tab]')];
    tabs.forEach((button) => button.addEventListener('click', () => {
      const isStore = button.dataset.reviewsTab === 'store';
      tabs.forEach((tab) => tab.classList.toggle('is-selected', tab === button));
      if (list) list.hidden = isStore;
      if (empty) empty.style.display = isStore ? 'block' : 'none';
      if (pager) pager.style.display = isStore ? 'none' : 'flex';
    }));

    showPage(1);
  };

  document.querySelectorAll('[data-reviews-root]').forEach(init);
})();
